import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-fieldset-wrapper',
    templateUrl: './fieldset-wrapper.component.html',
    styleUrls: ['./fieldset-wrapper.component.scss'],
    standalone: false
})
export class FieldsetWrapperComponent {
    /** Tamaño de texto para el <legend> (p.ej.: 'sm', 'base', 'md', 'lg', 'xl') */
    @Input() legendTextSize: string = 'lg';
    /** Si el texto del legend va en negrita o normal */
    @Input() boldLegend: boolean = true;
    /** Texto que aparece dentro del <b> o elemento de legend */
    @Input() title!: string;
    /** Número de columnas para md:grid-cols-{n} */
    @Input() cols: number = 1;
}
